import React from 'react'
import { useTranslation } from 'react-i18next'

import BaseContainer from '../common/BaseContainer'
import ControlHeader from '../common/ControlHeader'
import TopWidgetPanel from './TopWidgetPanel'
import DemographicsProfile from './Demographics'
import UserTypes from './UserTypes'
import Interests from './Interests'
import Marketing from './Marketing'
import SelectPlacement, { usePlacement } from '../common/SelectPlacement'
import { showLikesGraphOnAnalyticsTab } from '../../config'


const Analytics = () => {
  const { t } = useTranslation(['translation'])
  const {
    state,
    dispatch,
    render,
  } = usePlacement()

  return (
    <BaseContainer>
      <ControlHeader
        title={t('ANALYTICS.TITLE')}
        showTabs
        activeTab="analytics"
      />
      {render(() => (
        <div>
          <SelectPlacement state={state} dispatch={dispatch} />
          <TopWidgetPanel />
          <UserTypes state={state} />
          { showLikesGraphOnAnalyticsTab && (
            <Interests />
          )}
          <DemographicsProfile state={state} />
          <Marketing state={state} />
        </div>
      ))}
    </BaseContainer>
  )
}


export default Analytics
